import { createApp } from 'vue'
import App from './App.vue'
//import Vue from 'vue';

createApp(App).mount('#c-calendar-bandle');
//createApp(App).mount('.section-image-with-text-c');
